import LoadingView from 'components/Elements/LoadingView'
import ScrollToTopOnMount from 'components/ScrollToTopOnMount'
import AboutUs from 'sections/Website/AboutUs'
import Document from 'sections/Website/Document'
import GetStarted from 'sections/Website/GetStarted'
import Home from 'sections/Website/Home'
import HowItWorks from 'sections/Website/HowItWorks'
import YourBook from 'sections/Website/YourBook'
import { useEffect, useState } from 'react'
import { BrowserRouter as Router, Switch } from 'react-router-dom'
import RouteWrapper from './RouteWrapper'

import LogIn from 'components/auth/LogIn'
import Password from 'components/auth/Password'
import Register from 'components/auth/Register'
import Dashboard from 'sections/Dashboard'
import CheckoutComplete from 'sections/Website/GetStarted/CheckoutComplete'
import NoBook from 'sections/Website/NoBook'
import PricingPage from 'sections/Website/Pricing'
const { ForgotPassword, ForgotPasswordVerification } = Password

function Routes() {
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    // Cache hero imgs
    cacheImages([
      'https://image.anecdobio.com/home_hero1.jpg',
      'https://image.anecdobio.com/home_hero3.jpg',
      'https://image.anecdobio.com/home_hero4.jpg',
      'https://image.anecdobio.com/home_hero5.jpg',
      'https://image.anecdobio.com/home_hero6.jpg',
      'https://image.anecdobio.com/home_hero7.jpg',
      'https://image.anecdobio.com/home_hero8.jpg',
      'https://image.anecdobio.com/home_hero9.jpg',
      'https://image.anecdobio.com/home_hero11.jpg',
      'https://image.anecdobio.com/home_hero12.jpg',
      'https://image.anecdobio.com/home_hero13.jpg',
      'https://image.anecdobio.com/home_hero14.jpg',
    ])
  }, [])

  const cacheImages = async (imgs) => {
    const promises = await imgs.map((src) => {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.src = src
        img.onload = resolve()
        img.onerror = reject()
      })
    })

    await Promise.all(promises)
    setIsLoading(false)
  }

  return (
    <>
      {!isLoading ? (
        <Router>
          <ScrollToTopOnMount />
          <Switch>
            <RouteWrapper exact path="/" component={Home} isPublic />
            <RouteWrapper
              exact
              path="/your-book"
              component={YourBook}
              isPublic
            />
            <RouteWrapper
              exact
              path="/how-it-works"
              component={HowItWorks}
              isPublic
            />
            <RouteWrapper
              exact
              path="/pricing"
              component={PricingPage}
              isPublic
            />
            <RouteWrapper
              exact
              path="/get-started"
              component={GetStarted}
              isPublic
            />
            <RouteWrapper
              exact
              path="/checkout-complete"
              component={CheckoutComplete}
              isPublic
            />
            <RouteWrapper exact path="/no-book" component={NoBook} isPublic />
            <RouteWrapper
              exact
              path="/privacy"
              component={Document}
              docType="privacy"
              isPublic
            />
            <RouteWrapper
              exact
              path="/imprint"
              component={Document}
              docType="imprint"
              isPublic
            />
            <RouteWrapper
              exact
              path="/terms"
              component={Document}
              docType="terms"
              isPublic
            />
            <RouteWrapper exact path="/about-us" component={AboutUs} isPublic />
            <RouteWrapper exact path="/login" component={LogIn} isPublic />
            <RouteWrapper
              exact
              path="/register"
              component={Register}
              isPublic
            />
            <RouteWrapper
              exact
              path="/forgot-password"
              component={ForgotPassword}
              isPublic
            />
            <RouteWrapper
              exact
              path="/forgotpasswordverification"
              component={ForgotPasswordVerification}
              isPublic
            />
            <RouteWrapper path="/dashboard" component={Dashboard} />
          </Switch>
        </Router>
      ) : (
        <LoadingView isLoading={isLoading} />
      )}
    </>
  )
}

export default Routes
